// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1bbbd66","453":"1ebf3d5b","667":"cae95882","977":"60924a30"}[chunkId] + ".chunk.js";
};